import {
   Typography,
   Box,
   Dialog,
   DialogActions,
   DialogContent,
   DialogContentText,
   DialogTitle,
   IconButton,
} from '@mui/material';
import { useEffect, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { apiRequest, catchErrorMessageHandler } from '../../../infrastructure/backendService';
import { CommonButton, CommonOutlinedButton } from '../../common/StyledComponents/StyledFields';
import Pagination from '../../common/pagination/pagination';
import tablestyles from '../../devoteeService/devoteeService.module.scss';
import updateIcon from '../../../assets/svg/update_outline.svg';
import deleteIcon from '../../../assets/svg/delete_outline.svg';
import ErrorPopup from '../../common/ErrorPopup';
import constants from '../../../config/constants.json';
import commonStyles from '../../../App.module.scss';
import CloseIcon from '@mui/icons-material/Close';
import PoojaDetails from './poojaDetails';
import styles from './poojaDetails.module.scss';
import apiPath from '../../../config/apiPaths.json';

interface PoojaData {
   id: string; // Adjust the type of id property according to your actual data
}

const PoojaDetailsTable = () => {
   const [showAddButton, setShowAddButton] = useState<boolean>(true);
   const [showAddDonationType, setShowAddDonationType] = useState<boolean>(false);
   const [selectedId, setSelectedId] = useState<any | null | undefined>(null);
   const [pageNumber, setPageNumber] = useState<number>(1);
   const [totalRecords, setTotalRecords] = useState<number>(0);
   const [selectData, setSelectData] = useState<any>([]);
   const [selectedVastraPurposeId, setSelectedVastraPurposeId] = useState<any | null | undefined>(
      null,
   );
   const [selectedSuggestedAmmount, setSelectedSuggestedAmmount] = useState<any | null | undefined>(
      null,
   );
   const [isOpenDialog, setIsOpenDialog] = useState<boolean>(false);
   const [poojaDetailsList, setDonationPurposeList] = useState([]);
   const [isOpen, setIsOpen] = useState<boolean>(false);
   const [showPoojaDetailsFields, setShowPoojaDetailsFields] = useState<boolean>(false);

   const openConfirmPopUp1 = (id: number | undefined | null, suggestedDonation: any) => {
      setSelectedVastraPurposeId(id);
      setSelectedSuggestedAmmount(suggestedDonation);
      setIsOpenDialog(true);
   };

   const handleGetVastraPurposeData = (data: any) => {
      setSelectData(data);
      setSelectedVastraPurposeId(data?.id);
      setShowPoojaDetailsFields(true);
   };
   const handleAgree = () => {
      if (selectedVastraPurposeId !== null && poojaDetailsList) {
         // Find the index of the item with the selected ID in the addedItemsList
         const indexToRemove = poojaDetailsList.findIndex(
            (item: PoojaData) => item.id === selectedVastraPurposeId,
         );
         handleDeletePooja();
         if (indexToRemove !== -1) {
            // Create a copy of the addedItemsList without the selected item
            const updatedList = [...poojaDetailsList];
            updatedList.splice(indexToRemove, 1);
            // Update the addedItemsList and recalculate the total donation amount
            setDonationPurposeList(updatedList);
         }
      }
      // Close the dialog
      handleClose();
   };

   const handleClose = () => {
      setIsOpen(false);
      setIsOpenDialog(false);
      setSelectedId(null);
      setSelectedVastraPurposeId(null);
      setSelectedSuggestedAmmount(null);
   };
   const handleDeletePooja = () => {
      deletePoojaApiCall();
   };
   const deletePoojaApiCall = () => {
      const reqBody = {
         id: selectedVastraPurposeId,
         deleted: true,
         forDevotee: true,
         suggestedDonation: selectedSuggestedAmmount,
      };
      apiRequest({
         method: 'PUT',
         endpoint: `${apiPath.updatePoojaApi}/${selectedVastraPurposeId}`,
         includeToken: true,
         body: JSON.stringify(reqBody),
         params: {
            deleted: true,
         },
      })
         .then((res) => {
            console.log(res);
         })
         .catch((err) => {
            toast.custom(
               <ErrorPopup
                  showMessage={catchErrorMessageHandler(err)}
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
               />,
               {
                  duration: constants.TOAST_POPUP_DURATION,
               },
            );
         });
   };
   useEffect(() => {
      PoojaDetailsApiCall();
   }, [pageNumber]);
   const PoojaDetailsApiCall = () => {
      apiRequest({
         method: 'GET',
         endpoint: '/devotee-management/pooja',
         includeToken: true,
         params: {
            page: pageNumber - 1,
            size: 20,
            direction: 'asc',
         },
      })
         .then((res) => {
            setDonationPurposeList(res.data.content);
            setTotalRecords(res.data.totalElements);
         })
         .catch((err) => {
            toast.custom(
               <ErrorPopup
                  showMessage={catchErrorMessageHandler(err)}
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
               />,
               {
                  duration: constants.TOAST_POPUP_DURATION,
               },
            );
         });
   };

   const handleBackAdd = () => {
      setShowPoojaDetailsFields(false);
      PoojaDetailsApiCall();
   };
   const dialogPopup = () => {
      return (
         <Dialog
            open={isOpenDialog}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
               style: {
                  height: 'calc(100% - 128px)',
                  width: 'calc(100% - 128px)',
                  margin: '64px',
                  maxWidth: '504px',
                  maxHeight: '180px',
                  overflowY: 'unset',
                  borderTopLeftRadius: '16px',
                  borderTopRightRadius: '16px',
               },
            }}
         >
            <DialogTitle className={commonStyles.dialogTitle}>
               {'Please Confirm'}

               <IconButton
                  aria-label="close"
                  onClick={handleClose}
                  sx={{
                     position: 'absolute',
                     right: 24,
                     top: 12,
                     color: (theme: any) => theme.palette.grey[500],
                  }}
               >
                  <CloseIcon sx={{ color: 'white' }} />
               </IconButton>
            </DialogTitle>
            <DialogContent>
               <DialogContentText
                  id="alert-dialog-slide-description"
                  className={commonStyles.dialogContext}
               >
                  Are You Sure want to remove the Pooja details?
               </DialogContentText>
            </DialogContent>

            <DialogActions>
               <CommonOutlinedButton onClick={handleClose}>No</CommonOutlinedButton>
               <CommonButton onClick={handleAgree}>Yes</CommonButton>
            </DialogActions>
         </Dialog>
      );
   };

   const tableData = () => {
      return (
         <Box>
            <table className={tablestyles.tableContainer}>
               <thead>
                  <tr className={tablestyles.headerTableRow}>
                     <th className={tablestyles.tableHorizontal}>Name of the Pooja</th>
                     <th className={tablestyles.tableHorizontal}>Time</th>
                     <th className={tablestyles.tableHorizontal}>Donation (in Dollars)</th>
                     <th className={tablestyles.tableHorizontal}>Priest</th>
                     <th className={tablestyles.tableHorizontal}>For Devotee</th>
                     <th className={tablestyles.tableHorizontal}>Action</th>
                  </tr>
               </thead>
               <tbody className={tablestyles.tableBody} id="searchData">
                  {poojaDetailsList.map((row: any, id: number) => (
                     <tr key={id} className={tablestyles.tableRow}>
                        <td
                           className={tablestyles.tableDiagonal}
                           style={{
                              color: '#000',
                              fontWeight: 400,
                              textAlign: 'start',
                              paddingLeft: '21px',
                           }}
                        >
                           {row.name}
                        </td>
                        <td
                           className={tablestyles.tableDiagonal}
                           style={{
                              color: '#000',
                              fontWeight: 400,
                              textAlign: 'start',
                           }}
                        >
                           {row.duration} {'mins'}
                        </td>
                        <td
                           className={tablestyles.tableDiagonal}
                           style={{
                              color: '#000',
                              fontWeight: 400,
                              textAlign: 'start',
                           }}
                        >
                           {row.suggestedDonation}
                        </td>
                        <td
                           className={tablestyles.tableDiagonal}
                           style={{
                              color: '#000',
                              fontWeight: 400,
                              textAlign: 'start',
                           }}
                        >
                           {row.priestRequired ? <span>Yes</span> : <span>No</span>}
                        </td>

                        <td
                           className={tablestyles.tableDiagonal}
                           style={{
                              color: '#000',
                              fontWeight: 400,
                              textAlign: 'start',
                           }}
                        >
                           {row.forDevotee ? <span>Yes</span> : <span>No</span>}
                        </td>
                        <td
                           className={tablestyles.tableDiagonal}
                           style={{
                              fontWeight: 400,
                              color: '#000',
                              textAlign: 'start',
                           }}
                        >
                           <img src={updateIcon} onClick={() => handleGetVastraPurposeData(row)} />
                           <img
                              src={deleteIcon}
                              onClick={() => openConfirmPopUp1(row?.id, row.suggestedDonation)}
                           />
                        </td>
                     </tr>
                  ))}
               </tbody>
            </table>

            {totalRecords > 20 ? (
               <div
                  style={{
                     display: 'flex',
                     justifyContent: 'end',
                     marginRight: '10px',
                     marginTop: '3px',
                     float: 'right',
                  }}
               >
                  <Pagination
                     items={totalRecords}
                     itemsPerPage={20}
                     setPageNumber={setPageNumber}
                     pageNumber={pageNumber}
                  />
               </div>
            ) : (
               ''
            )}
         </Box>
      );
   };

   const handleAddPoojaDetails = () => {
      setShowPoojaDetailsFields(true);
      setShowAddButton(false);
      setSelectData('');
   };

   const poojaDetailsPage = () => {
      return !showPoojaDetailsFields ? (
         <>
            <Box className={styles.donationTableContainer}>
               <Typography className={styles.header}>Pooja Details</Typography>
               <CommonButton
                  className={styles.addnewButton}
                  onClick={handleAddPoojaDetails}
                  style={{ float: 'right', marginBottom: '10px' }}
               >
                  Add New
               </CommonButton>
            </Box>
            {tableData()}
         </>
      ) : (
         <PoojaDetails selectData={selectData} handleBack={handleBackAdd} />
      );
   };

   return (
      <div className={styles.mainContainer}>
         {poojaDetailsPage()}
         {dialogPopup()}
      </div>
   );
};
export default PoojaDetailsTable;
